import * as Sentry from '@sentry/react'
import { NODE_ENV, SENTRY_DSN } from './constants'

// Sentry lives in its own module so it can be imported — and Sentry.init run —
// *before* any other application module evaluates. index.tsx imports this first,
// ahead of ./App, which pulls in appkit.ts and builds the web3 / wallet stack at
// import time (new WagmiAdapter() + createAppKit()).
//
// Previously Sentry.init ran in index.tsx's *body*, i.e. after `import App` had
// already evaluated appkit.ts. So if that web3 init threw in a hostile
// environment — the in-app browser an email client opens links in, private mode,
// storage disabled — it threw before any error handler was armed, and the page
// went blank with nothing captured. With init hoisted here, Sentry's global
// handlers (window.onerror / unhandledrejection, installed by Sentry.init in
// @sentry/react v7) are listening in time to report even a module-evaluation
// crash that happens before React mounts.
if (NODE_ENV !== 'development') {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],

    // Performance monitoring
    tracesSampleRate: 0.05,
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}
